import {useCallback, useEffect} from "react"
import {useSelector} from "react-redux"
import {useRPC} from "./rpc"
import {useInterval} from "./interval"
import {getFormattedDayNameForWebsocket} from "../utils/format"

export function useDateTime() {
    const dateTimeSelector = useSelector(state => state.ui.dateTime)
    const [rpc] = useRPC()

    const runTime = useCallback(() => {
        rpc?.ping()
    }, [rpc])

    useEffect(() => runTime(), [runTime])

    useInterval(runTime, 10000)

    return {
        date: dateTimeSelector?.date,
        day: getFormattedDayNameForWebsocket(dateTimeSelector?.day),
        time: `${dateTimeSelector?.time?.[0]}${dateTimeSelector?.time?.[1]}:${dateTimeSelector?.time?.[3]}${dateTimeSelector?.time?.[4]}`
    }
}
